module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"article":"Favorite articles","noArticle":"You have not favorited any articles."},"ja":{"article":"お気に入りの記事","noArticle":"お気に入り登録された記事はありません"}}')
  delete Component.options._Ctor
}
